import React, { useState } from 'react';
import api from '../../utils/api';
import toast from 'react-hot-toast';
import { FiPhoneCall } from 'react-icons/fi';

interface TestCallPanelProps {
  defaultNumber?: string;
}

const TestCallPanel: React.FC<TestCallPanelProps> = ({ defaultNumber = '' }) => {
  const [numberToTest, setNumberToTest] = useState(defaultNumber);
  const [isTesting, setIsTesting] = useState(false);
  const [lastCallSid, setLastCallSid] = useState<string | null>(null);

  const handleTestCall = async () => {
    if (!numberToTest) {
      toast.error('Please enter a number to test.');
      return;
    }
    setIsTesting(true);
    setLastCallSid(null);
    const toastId = toast.loading('Initiating test call...');

    try {
      const response = await api.post('/test-call', { numberToTest });
      if (response.data.success) {
        toast.success(`Test call initiated. SID: ${response.data.callSid}`, { id: toastId });
        setLastCallSid(response.data.callSid);
      } else {
        toast.error('Failed to initiate test call.', { id: toastId });
      }
    } catch (error) {
      console.error('Test call error:', error);
      toast.error('An error occurred during the test call.', { id: toastId });
    } finally {
      setIsTesting(false);
    }
  };

  return (
    <div className="bg-gray-800 p-6 rounded-lg shadow-lg">
      <h3 className="text-lg font-semibold text-white mb-4">Test Call Verification</h3>
      <div className="flex items-center gap-4">
        <input
          type="tel"
          value={numberToTest}
          onChange={(e) => setNumberToTest(e.target.value)}
          placeholder="Enter number to test"
          className="flex-grow bg-gray-900 text-white border border-gray-600 rounded px-3 py-2"
        />
        <button 
          onClick={handleTestCall} 
          disabled={isTesting} 
          className="bg-indigo-600 hover:bg-indigo-500 text-white font-bold py-2 px-4 rounded inline-flex items-center disabled:opacity-50"
        >
          <FiPhoneCall className="mr-2" />
          {isTesting ? 'Calling...' : 'Place Test Call'}
        </button>
      </div>
      {lastCallSid && (
        <div className="mt-4 text-sm text-gray-400">
          Last call SID: <span className="font-mono">{lastCallSid}</span>
        </div>
      )}
    </div>
  );
};

export default TestCallPanel;
